module.exports = __webpack_public_path__ + "static/media/EwM-landscape.d4d6fe23.svg";